<!--
@component
Footer.Group

A group component for organizing content vertically or horizontally within the footer.

@prop direction - The layout direction of the group ('row' or 'column').
@prop css - Custom CSS styles to be applied to the group.
@prop use - Actions to be applied to the group element.

@example
<Footer.Group direction="column">
  <h3>Quick Links</h3>
  <Footer.Link href="/about">About Us</Footer.Link>
  <Footer.Link href="/contact">Contact</Footer.Link>
</Footer.Group>
-->

<script lang="ts">
  import type { FooterGroupProps } from '../footer.types';
  import { css } from '@agapi/ui/panda/css';
  import { footerStyles } from '../footer.styles';
  import { useActions } from '../../../utils/useAction';

  /** Props for the Footer.Group component. */
  let { use, children, direction = 'column', css: cssProp = {} }: FooterGroupProps = $props();

  /** Classes for the footer group. */
  const classes = footerStyles.raw({ direction });
</script>

<div use:useActions={use ?? []} class={css(classes.group, cssProp)}>
  {@render children?.()}
</div>